function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione04Popup01Ico07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.42 72.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.22,61.22c5.82,6.3,14.15,10.25,23.4,10.25,17.59,0,31.85-14.26,31.85-31.84,0-16.46-12.48-30-28.5-31.67M38.54.95C21.42,6.64,7.78,22.48,7.78,39.62M32.8,70.33s0-5.69,6.82-5.69c2.27,0,3.41,2.27,3.41,2.27l2.27-1.14M14.6,43.03c4.16-7.42,13.25-11.3,13.25-11.3,0,0,10.99,24.7-11.61,29.32M27.85,31.73s-1.4,21.53-11.63,29.49M16.22,61.22C9.11,55.28.95,41.95.95,41.95M16.87,61.23C.95,61.23.95,41.95.95,41.95c0,0,19.26,3.93,15.92,19.28ZM53.27,18.01h-6.32c-.98,0-1.85.63-2.16,1.55l-1.38,4.14c-.2.61.14,1.28.77,1.45l5.11,1.46c1.06.3,1.87,1.14,2.13,2.21h0c.36,1.44-.73,2.83-2.21,2.83h-6.74c-1.02,0-1.76.84-2.19,1.65l-1.61,2.98c-.3.66-.26,1.43.1,2.06l3.25,5.33c.62,1.01,1.72,1.63,2.91,1.63h.77c.44,0,.85.26,1.03.66l5.34,11.57c.61,1.32,2.27,1.74,3.43.87l.02-.02c1.43-1.07,2.28-2.76,2.28-4.55v-1.71l3.17-5.06c1.58-2.53,2.34-5.15,1.02-7.36l-1.82-3.05c-.32-.75.23-1.59,1.05-1.59h3.41M13.46,37.35c-3.49-.49-5.69-2.27-5.69-2.27-5.74-6.82-4.01-18.74,2.27-25.02C16.87,3.23,28.3.95,38.54.95c0,0,.88,16.59-7.25,27.37",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione04Popup01Ico07);
export default __webpack_public_path__ + "static/media/sezione-04-popup-01-ico-07.1ef8ed6ecb8bbb18ffb18078ac52d6f3.svg";
export { ForwardRef as ReactComponent };